export default {
      id: "icon-hobi-ve-oyun-odasi-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-hobi-ve-oyun-odasi",
      toString: function () {
        return this.url;
      }
    }